import styled from 'styled-components';
import { Black, Dark_Gray, White } from '../../colors';

export const Container = styled.div`
    width: 100vw;
    height: 54vh;
    margin-top: 150vh;
    background-color: ${Black};

    p{
        color: ${White};
        position: relative;
        left: calc(100vw - 95%) ;
        top: 5%;
        font-family: "Alata";
        color: ${Dark_Gray};
        background-color: ${Black};
        text-align: center;
        @media (min-width: 200px){
            left: 0;
            top: 0;
        }
        @media (max-width: 2560px){
            top: 2.5rem;
        }
        @media (max-width: 1200px){
            top: 3rem;
        }
        @media (max-width: 1000px){
            margin: 0 auto;
        }
    }


    @media (max-width: 2560px){
        position: relative;
        margin-top: calc(60vh);
        height: 20vh;
        justify-content: center;
    }

    @media (max-width: 1000px){
        margin-top: 150vh;
        height: 40vh;
    }

    @media (max-height: 700px){
        height: calc(100vmax - 50vh);
    }
    
    @media (max-height: 600px){
        height: calc(100vmax - 40vh);
    }
`;
export const Logo = styled.img`
    padding-top: 4.5rem;
    position: relative;
    left: calc(100vw - 70%) ;

    @media (max-width: 800px){
        margin: 0 calc(100% - 92vw);
    }

    @media (max-width: 600px){
        margin: 0 -.5em;
    }

    @media (max-width: 2560px){
        display: flex;
        max-width: 1200px;
        padding-top: 2.5rem;
        position: relative;
        justify-content: start;
        top: 0;
        left: 0;
    /* left: calc(100vw - 70%); */
    }

    @media (max-width: 1000px){
        position: static;
        top: 2vh;
    }
`;
export const FooterOption = styled.div`

    text-align: center;
    @media (max-width: 2560px){
        display: flex;
        max-width: 1200px;
        position: relative;
        text-align: none;
        top: 9vh;
        justify-content: flex-start;
        right: calc(100vmax - 90vw);
    }

    @media (max-width: 1800px){
        right: calc(100vmax - 89vw);
    }

    @media (max-width: 1800px){
        right: calc(100vmax - 87.5vw);
    }
    @media (max-width: 1400px){
        right: 16%;
    }

    @media (max-width: 1200px){
        right: 19%;
    }
    @media (max-width: 1000px){
        flex-direction: column;
        position: static;
        margin-top: 2vh;
        margin-bottom: 3vh;
    }
`;
export const Option = styled.div`
    color: ${White};
    background-color: ${Black};
    font-family: "Alata";
    cursor: pointer;
    margin-bottom: 1.3rem;
    &:first-child{
        margin-top: 2rem;
    }
    &:last-child{
        margin-bottom: 2.5rem;
        @media (min-width: 200px){
            margin-bottom: 0;
            background-color: ${Black};
            right: -50em;
        }
    }

    @media (max-width: 2560px){
        display: flex;
        max-width: 1200px;
        background-color: none;
        margin-left: 1em;
        &:first-child{
            margin: 0;
            background-color: transparent;
        }
    }

    @media (max-width: 1000px){
        margin: 0;
        justify-content: center;
    }
`;
export const FooterSocial = styled.div`
    margin: 0 auto;
    position: relative;
    left: calc(100vw - 65%) ;
    background-color: ${Black};
    @media (min-width: 200px){
        left: 0;
        margin-top: 1em;
        text-align: center;
    }
    @media (max-width: 800px){
        margin: 2vh  calc(100% - 94vw) 0 8vw;
    }

    @media (max-width: 2560px){
        display: flex;
        max-width: 1200px;
        background-color: none;
        justify-content: flex-end;
        left: calc(100vw - 130%);
    }
    @media (max-width: 1800px){
        left: calc(100vw - 117%);
    }

    @media (max-width: 1800px){
        left: calc(100vw - 100%);
    }

    @media (max-width: 1400px){
        left: 30%;
    }
    @media (max-width: 1200px){
        left: 25%;
    }

    @media (max-width: 1000px){
        position: static;
    }
`;
export const SocialLogo = styled.img`
    margin-right: 1.5em;
    background-color: ${Black};

    @media (max-width: 2560px){
        display: flex;
        max-width: 1200px;
        background-color: none;
    }
`;

export const SubContainer = styled.div`
    @media (max-width:2560px){
        display: flex;
        max-width: 1200px;
        margin: 0 auto;
        align-items: center;
    }
    @media (max-width: 1200px){
        max-width: 1000px;
    }
    @media (max-width: 1000px){
        flex-direction: column;
        align-items: center;
    }
`;